var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useRef } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useQueryClient } from "react-query";
import { fetchAgencyPublishers, fetchPublisherBySourceId, } from "../../api/publisherService";
import { formatPublisherLabel } from "../../utils/formatPublisherLabel";
import { normalizeMunicipality } from "../../utils/normalizeMunicipality";
import { agencyPublisherQueryKey, publisherMunicipalityQueryKey, useResolvePublisher, } from "./useResolvePublisher";
export var useAgencyPublisherHandlers = function (params) {
    var _a, _b, _c;
    var okapiKy = useOkapiKy();
    var queryClient = useQueryClient();
    var resolvePublisherById = useResolvePublisher().resolvePublisherById;
    var setOwnerSelectOptions = (_a = params.setOwnerSelectOptions) !== null && _a !== void 0 ? _a : params.setOwnerOptions;
    var setPublisherSelectOptions = (_b = params.setPublisherSelectOptions) !== null && _b !== void 0 ? _b : params.setPublisherOptions;
    var setFormValue = (_c = params.setFormValue) !== null && _c !== void 0 ? _c : params.setValue;
    var trigger = params.trigger;
    var publisherRequestIdRef = useRef(0);
    var prefillMunicipalityFromPublisher = function (fullPublisher) { return __awaiter(void 0, void 0, void 0, function () {
        var municipality, publisherDetail, error_1, existingPlaces, hasOnlyEmptyPlaceholder, formOptions;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!params.isCreateMode || !(fullPublisher === null || fullPublisher === void 0 ? void 0 : fullPublisher.sourceId) || !params.getValues) {
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, queryClient.fetchQuery(publisherMunicipalityQueryKey(fullPublisher.sourceId), function () { return fetchPublisherBySourceId(okapiKy, fullPublisher.sourceId); })];
                case 2:
                    publisherDetail = _c.sent();
                    municipality = normalizeMunicipality((_a = publisherDetail === null || publisherDetail === void 0 ? void 0 : publisherDetail.mainAddress) === null || _a === void 0 ? void 0 : _a.municipality);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.error("Error fetching publisher municipality:", error_1);
                    return [2 /*return*/];
                case 4:
                    if (!municipality)
                        return [2 /*return*/];
                    existingPlaces = params.getValues("publicationPlaces") || [];
                    if (existingPlaces.some(function (place) { return place.city === municipality; }))
                        return [2 /*return*/];
                    hasOnlyEmptyPlaceholder = existingPlaces.length === 1 && !((_b = existingPlaces[0]) === null || _b === void 0 ? void 0 : _b.city);
                    formOptions = {
                        shouldDirty: true,
                        shouldTouch: true,
                        shouldValidate: false,
                    };
                    if (hasOnlyEmptyPlaceholder) {
                        setFormValue("publicationPlaces", [{ city: municipality }], formOptions);
                    }
                    else {
                        setFormValue("publicationPlaces", __spreadArray(__spreadArray([], existingPlaces, true), [{ city: municipality }], false), formOptions);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAgencyPublisherSelectionChange = function (entityKind, index) {
        return function (selectedPublisherId) { return __awaiter(void 0, void 0, void 0, function () {
            var requestId, formPath, fullPublisher, option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestId = ++publisherRequestIdRef.current;
                        formPath = entityKind === "owner"
                            ? "owner"
                            : "titlePublishers.".concat(index, ".publisher");
                        setFormValue(formPath, { id: selectedPublisherId }, {
                            shouldDirty: true,
                            shouldTouch: true,
                            shouldValidate: false,
                        });
                        return [4 /*yield*/, resolvePublisherById(selectedPublisherId)];
                    case 1:
                        fullPublisher = _a.sent();
                        if (requestId !== publisherRequestIdRef.current)
                            return [2 /*return*/];
                        if (fullPublisher) {
                            option = {
                                value: fullPublisher.id,
                                label: formatPublisherLabel(fullPublisher),
                            };
                            if (entityKind === "owner") {
                                setOwnerSelectOptions([option]);
                            }
                            else {
                                setPublisherSelectOptions([option]);
                            }
                            setFormValue(formPath, fullPublisher, {
                                shouldDirty: true,
                                shouldTouch: true,
                                shouldValidate: false,
                            });
                        }
                        else {
                            setFormValue(formPath, {}, {
                                shouldDirty: true,
                                shouldTouch: true,
                                shouldValidate: false,
                            });
                        }
                        return [4 /*yield*/, trigger(formPath)];
                    case 2:
                        _a.sent();
                        if (!(entityKind === "publisher")) return [3 /*break*/, 4];
                        return [4 /*yield*/, prefillMunicipalityFromPublisher(fullPublisher)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    var onAgencyPublisherAsyncFilter = function (entityKind) { return function (filterValue) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, items, mappedOptions;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchAgencyPublishers(okapiKy, {
                        query: "name==\"*".concat(filterValue, "*\""),
                        limit: 50,
                        offset: 0,
                    })];
                case 1:
                    _a = (_b.sent()).items, items = _a === void 0 ? [] : _a;
                    items.forEach(function (publisher) {
                        if (publisher.id) {
                            queryClient.setQueryData(agencyPublisherQueryKey(publisher.id), publisher);
                        }
                    });
                    mappedOptions = items.map(function (publisher) { return ({
                        value: publisher.id,
                        label: formatPublisherLabel(publisher),
                    }); });
                    if (entityKind === "owner") {
                        setOwnerSelectOptions(mappedOptions);
                    }
                    else {
                        setPublisherSelectOptions(mappedOptions);
                    }
                    return [2 /*return*/];
            }
        });
    }); }; };
    return {
        handleAgencyPublisherSelectionChange: handleAgencyPublisherSelectionChange,
        onAgencyPublisherAsyncFilter: onAgencyPublisherAsyncFilter,
        prefillMunicipalityFromPublisher: prefillMunicipalityFromPublisher,
        handleAgencyPublisherChange: handleAgencyPublisherSelectionChange,
        onEntityFilter: onAgencyPublisherAsyncFilter,
    };
};
